export default {
  quick_links: {
    title: 'Schnellzugriff',
    developers: 'Bauträger',
    agencies: 'Agenturen',
    properties: 'Objekte',
  },
  company: {
    title: 'Über das Unternehmen',
    about_services: 'Über den Service',
    news: 'Nachrichten',
    statistic: 'Statistik',
  },
  support: {
    title: 'Support',
  },
  get_in_touch: 'Kontaktieren Sie uns',
  email: 'info(at)estimator24.com',
  phone: '+41762378017',
  copyright: 'Estimator24.com'
}
